<h1 class="mb-40 h2 text-black text-center">
  {{ text }}
</h1>
